/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetFuelPriceResponse
 */
export interface GetFuelPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof GetFuelPriceResponse
     */
    fuelPricePerUsd: number;
}

/**
 * Check if a given object implements the GetFuelPriceResponse interface.
 */
export function instanceOfGetFuelPriceResponse(value: object): value is GetFuelPriceResponse {
    if (!('fuelPricePerUsd' in value) || value['fuelPricePerUsd'] === undefined) return false;
    return true;
}

export function GetFuelPriceResponseFromJSON(json: any): GetFuelPriceResponse {
    return GetFuelPriceResponseFromJSONTyped(json, false);
}

export function GetFuelPriceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFuelPriceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fuelPricePerUsd': json['fuelPricePerUsd'],
    };
}

export function GetFuelPriceResponseToJSON(json: any): GetFuelPriceResponse {
    return GetFuelPriceResponseToJSONTyped(json, false);
}

export function GetFuelPriceResponseToJSONTyped(value?: GetFuelPriceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fuelPricePerUsd': value['fuelPricePerUsd'],
    };
}

